import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { http } from "../lib/api";
import { getColor } from "../lib/categoryColors";

const Ctx = createContext(null);

export function CategoriesProvider({ children }) {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await http.get("/categories");
      setCategories(data);
    } catch (e) {
      // Non-fatal: keep the previous list. Surface to the console so the issue isn't hidden.
      // eslint-disable-next-line no-console
      console.warn("Failed to load categories:", e?.message || e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const byName = useMemo(() => {
    const m = {};
    for (const c of categories) m[c.name] = c;
    return m;
  }, [categories]);

  const colorForFolder = useCallback(
    (folderName) => getColor(byName[folderName]?.color),
    [byName]
  );

  const value = useMemo(
    () => ({ categories, loading, refresh, byName, colorForFolder }),
    [categories, loading, refresh, byName, colorForFolder]
  );

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useCategories() {
  const ctx = useContext(Ctx);
  if (!ctx) {
    return { categories: [], loading: true, refresh: () => {}, byName: {}, colorForFolder: getColor };
  }
  return ctx;
}
